import { render, staticRenderFns } from "./GroupBuyTablePane.vue?vue&type=template&id=1a4b1d3d&scoped=true"
import script from "./GroupBuyTablePane.vue?vue&type=script&lang=js"
export * from "./GroupBuyTablePane.vue?vue&type=script&lang=js"
import style0 from "./GroupBuyTablePane.vue?vue&type=style&index=0&id=1a4b1d3d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4b1d3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a4b1d3d')) {
      api.createRecord('1a4b1d3d', component.options)
    } else {
      api.reload('1a4b1d3d', component.options)
    }
    module.hot.accept("./GroupBuyTablePane.vue?vue&type=template&id=1a4b1d3d&scoped=true", function () {
      api.rerender('1a4b1d3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/groupBuy/GroupBuyTablePane.vue"
export default component.exports